import { render, staticRenderFns } from "./CertificateProgress.vue?vue&type=template&id=4bb306c9&scoped=true&"
import script from "./CertificateProgress.vue?vue&type=script&lang=js&"
export * from "./CertificateProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb306c9",
  null
  
)

export default component.exports